import { Button, CircularProgress, makeStyles, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import RoutePaths from '../../config/Routes';
import { updateMyPassword } from '../../services/Auth';
import formInput from '../../theme/styles/FormInput';
import Validations, {
  MaxLengthValidationFunc,
  MinLengthValidationFunc,
} from '../../utils/Validations';
import SnackbarMessage from '../SnackbarMessage';

const useStyles = makeStyles(formInput);

const ChangePasswordForm = () => {
  const classes = useStyles();
  const history = useHistory();

  const [processing, setProcessing] = useState(false);
  const [snackbarMeesage, setSnackbarMeesage] = useState({
    show: false,
    type: '',
    message: '',
  });

  const { handleSubmit, control, reset } = useForm();

  const submitForm = (data) => {
    setProcessing(true);
    setSnackbarMeesage({
      ...snackbarMeesage,
      message: '',
      type: '',
      show: false,
    });
    updateMyPassword(data)
      .then(() => {
        setProcessing(false);
        setSnackbarMeesage({
          ...snackbarMeesage,
          message: 'Your password has been updated successfully.',
          type: 'success',
          show: true,
        });
        reset();
        history.push(RoutePaths.LOGOUT);
      })
      .catch(({ response }) => {
        setSnackbarMeesage({
          ...snackbarMeesage,
          message: response.data.message,
          type: 'error',
          show: true,
        });
        setProcessing(false);
      });
  };

  return (
    <form onSubmit={handleSubmit(submitForm)} id="change-pwd">
      <Controller
        control={control}
        rules={Validations.REQUIRED}
        name="currentPassword"
        id="currentPassword"
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            type="password"
            variant="outlined"
            label="Current Password*"
            value={value}
            onChange={onChange}
            error={!!error}
            helperText={error ? error.message : null}
            className={classes.formInput}
            fullWidth
          />
        )}
      />
      <Controller
        control={control}
        rules={{
          ...Validations.REQUIRED,
          ...MaxLengthValidationFunc(80),
          ...MinLengthValidationFunc(6),
        }}
        name="newPassword"
        id="newPassword"
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            type="password"
            variant="outlined"
            label="New Password*"
            value={value}
            onChange={onChange}
            error={!!error}
            helperText={error ? error.message : null}
            className={classes.formInput}
            fullWidth
          />
        )}
      />
      <Controller
        control={control}
        rules={{
          ...Validations.REQUIRED,
          ...MaxLengthValidationFunc(80),
          ...MinLengthValidationFunc(6),
        }}
        name="confirmPassword"
        id="confirmPassword"
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            type="password"
            variant="outlined"
            label="Confirm New Password*"
            value={value}
            onChange={onChange}
            error={!!error}
            helperText={error ? error.message : null}
            className={classes.formInput}
            fullWidth
          />
        )}
      />
      <Button
        variant="contained"
        color="primary"
        type="submit"
        form="change-pwd"
        disableElevation
        endIcon={processing && <CircularProgress size={25} />}
        disabled={processing}
      >
        Update
      </Button>
      {snackbarMeesage.show && <SnackbarMessage {...snackbarMeesage} />}
    </form>
  );
};

export default ChangePasswordForm;
